import { render, staticRenderFns } from "./DotNumber.vue?vue&type=template&id=1012f7a6"
import script from "./DotNumber.vue?vue&type=script&lang=js"
export * from "./DotNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports